const questionPrefix = 'xnxj-'

export function setQuestionParams(type, params){
    const now = Date.now();
    localStorage.setItem(
        questionPrefix+type,
        JSON.stringify({
            timestamp: now,
            params: params,
        })
    )
}

export function getActiveQuestion(type){
    if (typeof window === 'undefined') {
        return null; // SSR 环境返回默认值
    }
    const cachedData = JSON.parse(localStorage.getItem(questionPrefix+type));
    const now = Date.now();

    const cacheExpiry = 10 * 60 * 1000 //10分钟

    if (cachedData && (now - cachedData.timestamp < cacheExpiry)) {
        // 返回缓存的结果
        return cachedData.params;
    }

    return null
}

export function removeQuestion(type){
    localStorage.removeItem(questionPrefix+type);
}